import { lazy } from 'react'

export const QrScanPage = lazy(() => import('../../pages/qr/QrScanPage'))
export const DailyInspectionPageQr = lazy(() => import('../../pages/qr/DailyInspectionPage'))
export const PeriodicInspectionPageQr = lazy(() => import('../../pages/qr/PeriodicInspectionPage'))
export const DailyInspectionPage = lazy(() => import('../../pages/inspections/DailyInspectionPage'))
export const PeriodicInspectionPage = lazy(() => import('../../pages/inspections/PeriodicInspectionPage'))
